import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import "./StatsCounter.scss";
import { useScrollReveal } from "../../../motion/useScrollReveal";
import { prefersReducedMotion } from "../../../motion/prefersReducedMotion";

interface Stat {
  value: number;
  suffix: string;
  label: string;
}

const STATS: Stat[] = [
  { value: 15, suffix: "+", label: "Years in iGaming" },
  { value: 400, suffix: "+", label: "Consultants" },
  { value: 30, suffix: "+", label: "Delivery Centres Worldwide" },

];

const StatsCounter: React.FC = () => {
  // Count-up fires once, when the section scrolls into view.
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const reducedMotion = prefersReducedMotion();
  // Each stat item rises + fades in, staggered, as the row enters the viewport.
  const revealRef = useScrollReveal<HTMLDivElement>({
    selector: ".stats__item",
    stagger: 0.15,
  });

  return (
    <section
      id="stats"
      className="stats"
      ref={ref}
      aria-label="Nagarro iGaming statistics"
    >
        <div className="stats__inner" ref={revealRef}>
          {STATS.map((stat) => (
            <div className="stats__item" key={stat.label}>
              <div className="stats__number">
                {inView ? (
                  <CountUp end={stat.value} duration={reducedMotion ? 0 : 2} />
                ) : (
                  0
                )}
                <span className="stats__plus">{stat.suffix}</span>
              </div>
              <div className="stats__label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>
  );
};

export default StatsCounter;
